<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title float-left" v-if="region.id"> Изменить регион</h4>
                        <h4 class="card-title float-left" v-else> Добавить регион</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="name">Название <span class="red">*</span></label>
                                    <input type="text" class="form-control" id="name" v-model="region.name"
                                        :class="{invalid : $v.region.name.$error}"
                                        @blur="$v.region.name.$touch()">
                                    <div class="red" v-if="$v.region.name.$error">Пожалуйста, введите название</div>
                                </div>
                                <div class="form-group">
                                    <label>Родитель</label>
                                    <v-select v-model="region.parent" label="name"
                                            :options="parents"
                                            :filterable="false"
                                            @search="onParentSearch"
                                            @search:focus="onParentFocus()"></v-select>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <label>Место нахождения</label>
                                <GmapMap
                                    :center="center"
                                    :zoom="7"
                                    style="width: 100%; height: 300px"
                                    @click="onMapClick">
                                    <GmapMarker
                                        v-if="region.location && region.location.lat && region.location.lng"
                                        :position="region.location"
                                        :clickable="true"
                                        :draggable="true"/>
                                </GmapMap>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-md-12 text-center">
                                <button class="btn btn-default" @click="cancel" :disabled="processing">Отменить</button>
                                <button class="btn btn-success ml-3" @click="save" :disabled="processing">Сохранить</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import {DEFAULT_LOCATION} from '@/shared/constants'

    export default {
        name: "RegionEdit",
        data() {
            return {
                processing: false,
                center: DEFAULT_LOCATION,
                region: {
                    id: null,
                    name: '',
                    parent: null,
                    location: {
                        lat: DEFAULT_LOCATION.lat,
                        lng: DEFAULT_LOCATION.lng
                    }
                },
                parents: []
            }
        },
        validations: {
            region: {
                name: {
                    required: required
                }
            }
        },
        methods: {
            onMapClick(event) {
                this.region.location = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                }
            },
            cancel() {
                this.$router.push('/region');
            },
            load(id) {
                this.$http.get('region/' + id)
                    .then(res => {
                        res = res.data;
                        if (!res.location) {
                            res.location = {
                                lat: DEFAULT_LOCATION.lat, 
                                lng: DEFAULT_LOCATION.lng
                            }
                        }
                        this.center = res.location;
                        this.region = res;
                    }, err => {
                        console.log(err);
                    });
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    // this.$messageBox.warning('Пожалуйста, заполните обязательные поля!');
                    return;
                }
                this.processing = true;
                this.$http.post('region', this.region)
                    .then(res => {
                        console.log(res.data);
                        this.$router.push('/region');
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            onParentSearch(searchTxt, loading) {
                loading(true);
                const excluded = [];
                if (this.region.id && this.region.id > 0) {
                    excluded.push(this.region.id);
                }
                this.$http.post('region/choose', {excludedIds: excluded, search: searchTxt})
                    .then(res => {
                        this.parents = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onParentFocus: function () {
                const excluded = [];
                if (this.region.id && this.region.id > 0) {
                    excluded.push(this.region.id);
                }
                this.$http.post('region/choose', {excludedIds: excluded, search: ''})
                    .then(res => {
                        this.parents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            const id = this.$route.params.id;
            if (id && id > 0) {
                this.load(id);
            }
        }
    }
</script>

<style scoped>

</style>